if (objects.is_concept){

    const titre = new SplitText("h1.title", { type: "words,chars" }),
    charsTitre = titre.chars; //an array of all the divs that wrap each character

    gsap.fromTo(charsTitre, {
        scale: 0,
        ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
    }, {
        scrollTrigger: {
            trigger: "h1.title",
        },
        scale: 1,
        stagger: 0.01,
        delay: 1,
        duration: 0.5,
    });

    // gsap.fromTo('#section-concept-1>.wrapper>div', {
    //     y: -200,
    //     opacity: 0,
    // }, {
    //     scrollTrigger: {
    //         trigger: ".wrapper>div",
    //     },
    //     y: 0, 
    //     ease: "power3.out",
    //     opacity: 1,
    //     delay: 1.5,
    //     duration: 1,
    //     stagger: 0.5,
    // });

    // gsap.fromTo('#section-concept-2>div', {
    //     y: -200,
    //     opacity: 0,
    // }, {
    //     scrollTrigger: {
    //         trigger: "#section-concept-2>div",
    //     },
    //     y: 0, 
    //     ease: "power3.out",
    //     opacity: 1,
    //     delay: 1,
    //     duration: 1,
    //     stagger: 0.5,
    // });


    if (window.innerWidth >= 992){

        //1

        gsap.fromTo('.dotted-1', {
            height: 0,
        }, {
            scrollTrigger: {
                trigger: ".dotted-1",
            },
            height: 225, 
            ease: "power3.out",
            delay: 1,
            duration: 0.5,
        });

        gsap.fromTo('.dotted-1', {
            width: 0,
        }, {
            scrollTrigger: {
                trigger: ".dotted-1",
            },
            width: 75, 
            ease: "power3.out",
            delay: 1.5,
            duration: .5,
        });

        /////////////////////////
        // gsap.fromTo('.dotted-1.height', {
        //     height: 0,
        // }, {
        //     scrollTrigger: {
        //         trigger: ".dotted-1.height",
        //     },
        //     height: 225, 
        //     ease: "power3.out",
        //     delay: 1,
        //     duration: 0.5,
        // });

        // gsap.fromTo('.dotted-1.width', {
        //     width: 0,
        // }, {
        //     scrollTrigger: {
        //         trigger: ".dotted-1.width",
        //     },
        //     width: 75, 
        //     ease: "power3.out",
        //     delay: 1.5,
        //     duration: .5,
        // });
/////////////////////////

        gsap.fromTo('.cadre-1', {
            y: -200,
            opacity: 0,
        }, {
            scrollTrigger: {
                trigger: ".cadre-1",
            },
            y: 0,
            opacity: 1,
            ease: "power3.out",
            delay: 2,
            duration: 1,
        });

        gsap.fromTo('.img-holder-1', {
            y: -200,
            opacity: 0,
        }, {
            scrollTrigger: {
                trigger: ".img-holder-1",
            },
            y: 0,
            opacity: 1,
            ease: "power3.out",
            delay: 3,
            duration: 1,
        });

        //2

        gsap.fromTo('.dotted-2', {
            height: 0,
        }, {
            scrollTrigger: {
                trigger: ".dotted-2",
            },
            height: 230, 
            ease: "power3.out",
            delay: 3,
            duration: 0.5,
        });

        gsap.to('.dotted-2', {
            scrollTrigger: {
                trigger: ".cadre-2",
            },
            height: 460, 
            ease: "power3.out",
            delay: 0,
            duration: 0.5,
        });

        gsap.fromTo('.dotted-2', {
            width: 0,
        }, {
            scrollTrigger: {
                trigger: ".cadre-2",
            },
            width: 215, 
            ease: "power3.out",
            delay: .5,
            duration: .5,
        });

        gsap.fromTo('.cadre-2', {
            y: -200,
            opacity: 0,
        }, {
            scrollTrigger: {
                trigger: ".img-holder-2",
            },
            y: 0,
            opacity: 1,
            ease: "power3.out",
            delay: 0,
            duration: 1,
        });

        gsap.fromTo('.img-holder-2', {
            y: -200,
            opacity: 0,
        }, {
            scrollTrigger: {
                trigger: ".img-holder-2",
            },
            y: 0,
            opacity: 1,
            ease: "power3.out",
            delay: 1,
            duration: 1,
        });


        //3

        gsap.fromTo('.dotted-3', {
            height: 0,
        }, {
            scrollTrigger: {
                trigger: ".dotted-3",
            },
            height: 385, 
            ease: "power3.out",
            delay: 1,
            duration: 0.5,
        });
    
        gsap.fromTo('.texte-3', {
            y: -200,
            opacity: 0,
        }, {
            scrollTrigger: {
                trigger: "#img-holder-4",
            },
            y: 0,
            opacity: 1,
            ease: "power3.out",
            delay: 0.5,
            duration: 1,
        });


        //4

        gsap.fromTo('.dotted-4', {
            height: 0,
        }, {
            scrollTrigger: {
                trigger: ".dotted-4",
            },
            height: 500, 
            ease: "power3.out",
            delay: 1,
            duration: 1,
        });

        gsap.fromTo('.texte-4', {
            y: -200,
            opacity: 0,
        }, {
            scrollTrigger: {
                trigger: ".texte-4",
            },
            y: 0,
            opacity: 1,
            ease: "power3.out",
            delay: 1.5,
            duration: 1,
        });


        //5

        gsap.fromTo('.dotted-5', {
            height: 0,
        }, {
            scrollTrigger: {
                trigger: ".dotted-5",
            },
            height: 210, 
            ease: "power3.out",
            delay: 0,
            duration: 1,
        });

        gsap.fromTo('.texte-5', {
            y: -200,
            opacity: 0,
        }, {
            scrollTrigger: {
                trigger: ".dotted-6",
            },
            y: 0,
            opacity: 1,
            ease: "power3.out",
            delay: 0.5,
            duration: 1,
        });

    
        //6

        gsap.fromTo('.dotted-6', {
            height: 0,
        }, {
            scrollTrigger: {
                trigger: ".dotted-6",
            },
            height: 210, 
            ease: "power3.out",
            delay: 1,
            duration: 1,
        });

        gsap.fromTo('.accroche-bas', {
            y: -200,
            opacity: 0,
        }, {
            scrollTrigger: {
                trigger: "#site-footer",
            },
            y: 0,
            opacity: 1,
            ease: "power3.out",
            delay: 1.5,
            duration: 1,
        });
    }



}